import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sid = params.get("session_id");
    (async () => {
      if (!sid) {
        navigate("/");
        return;
      }
      try {
        const { data } = await axios.post(
          `${API}/auth/session`,
          {},
          { headers: { "X-Session-ID": sid }, withCredentials: true }
        );
        setUser(data);
        navigate("/espace", { replace: true, state: { user: data } });
      } catch {
        navigate("/");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-950 text-white gap-4">
      <Loader2 className="w-8 h-8 animate-spin text-sky-400" />
      <span className="mono text-sm text-slate-400">Connexion en cours…</span>
    </div>
  );
}
